import React, { useState, useEffect } from "react";
import styles from "./styles.css";
import Copy from "./images/copy.svg";
import Twitter from "./images/twitter.svg";
import FB from "./images/fb.svg";
import InputMobile from "../../shared/input-mobile";
import IconSendMsg from "../../shared/icon-send-msg/component";
import { CopyToClipboard } from "react-copy-to-clipboard";
import PropTypes from "prop-types";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import queryString from "querystring";
import GreenTick from "./images/green-tick.svg";
import useToggle from "../../../hooks/use-toggle";

const ReferFriend = ({
    referral,
    sendReferralMessageConnect,
    config
}) => {
    const [isMobileFocused, setIsMobileFocused] = useToggle();

    const [isMessageSent, setIsMessageSent] = useState(false);

    const [isSentOnce, setIsSentOnce] = useState(false);

    const [error, setError] = useState();

    const [mobile, setMobile] = useState("");

    const [isCopied, setIsCopied] = useState(false);

    const onMobileChangeHandler = (e) => {
        if (isMessageSent) setIsMessageSent(false);
        if (error) setError();
        setMobile(e.target.value);
    };

    const onSend = () => {
        const payload = {
            phone_number: mobile,
            referral_id: referral.referral_id
        };
        sendReferralMessageConnect(payload)
            .then(() => {
                setIsSentOnce(true);
                setMobile("");
                setIsMessageSent(true);
                setError();
            })
            .catch((err) => {
                setError(JSON.parse(err.message).phone_number.toString());
            });
    };

    const getDisabledStatus = () => mobileNumberValidator(mobile);

    const getWidgetURL = (type) => {
        return {
            [config[type].sharerURLKey]: referral.referral_url,
            [config[type].sharerTitleKey]: config[type].title
        };
    };

    useEffect(() => {
        if (isCopied) {
            window.setTimeout(() => {
                setIsCopied(false);
                // eslint-disable-next-line no-magic-numbers
            }, 2000);
        }
    }, [isCopied]);

    return (
        <div styleName={"styles.padding"}>
            <p styleName={"styles.heading"}>Share your link</p>
            <div styleName={"styles.link"}>
                <h2>{referral.referral_url}</h2>
                <CopyToClipboard
                    onCopy={() => setIsCopied(true)}
                    text={referral.referral_url}>
                    <img src={Copy} />
                </CopyToClipboard>
                {
                    isCopied &&
                    <p styleName={"styles.copied"}>Copied</p>
                }
            </div>

            <div styleName={"styles.btnWrap"}>
                <a
                    href={`${config.twitter.sharer}?${
                        queryString.stringify(getWidgetURL("twitter"))}`}
                    target="_blank">
                    <button styleName={"styles.twitter"}>
                        <span>
                            <img src={Twitter} />
                        </span>
                        Tweet it!
                    </button>
                </a>
                <a
                    href={`${config.facebook.sharer}?${
                        queryString.stringify(getWidgetURL("facebook"))}`}
                    target="_blank">
                    <button styleName={"styles.fb"}>
                        <span>
                            <img src={FB} />
                        </span>
                        Post it!
                    </button>
                </a>
            </div>
            <div styleName={"styles.divider"}>
                <p>Or</p>
            </div>
            <p
                styleName={"styles.numberHead"}>
                Share {isSentOnce ? "another" : "your"} friend’s number with us!
            </p>
            <div styleName={"styles.inputWrap"}>
                <InputMobile
                    onFocusCallback={setIsMobileFocused}
                    onBlurCallback={setIsMobileFocused}
                    value={mobile}
                    onChange={onMobileChangeHandler} />
                <button
                    style={{ borderLeft: isMobileFocused ? "2px solid #ed6c0d" : "" }}
                    disabled={!getDisabledStatus()}
                    onClick={onSend}>
                    <IconSendMsg />
                </button>
                {
                    isMessageSent &&
                    <p styleName={"styles.successMessage"}>
                        <span>
                            <img src={GreenTick} />
                        </span>Shared Successfully!
                    </p>
                }
                {
                    error &&
                    <p styleName={"styles.error"}>{error}</p>
                }
            </div>
        </div>

    );
};

ReferFriend.propTypes = {
    referral: PropTypes.object,
    sendReferralMessageConnect: PropTypes.func,
    config: PropTypes.config
};

export default ReferFriend;
